import { apolloClient } from "@/apollo.provider";

import { GET_USER } from "@/graphql/user/queries";
import { AccessRight } from "../typesDefinition";
import { User } from "../user/typesDefinition";

export async function getUser(): Promise<User> {
  const result = await apolloClient.query({
    query: GET_USER,
  });
  return result.data.user;
}

export function hasRole(
  role: string,
  accessRights: AccessRight[] | undefined,
): boolean {
  if (!accessRights) return false;
  return accessRights.some((accessRight) => accessRight.role === role);
}

export function isAdmin(accessRights: AccessRight[] | undefined): boolean {
  if (!accessRights) return false;
  return accessRights.some(
    (accessRight) =>
      accessRight.role === "admin" || accessRight.role === "super_admin",
  );
}

export function isEmployee(accessRights: AccessRight[] | undefined): boolean {
  return hasRole("employee", accessRights);
}

export function isClient(accessRights: AccessRight[] | undefined): boolean {
  return hasRole("client", accessRights);
}

export function isProjectManager(
  accessRights: AccessRight[] | undefined,
): boolean {
  return hasRole("project_manager", accessRights);
}

export function isFinancial(accessRights: AccessRight[] | undefined): boolean {
  return hasRole("financial", accessRights);
}

export function isCFO(accessRights: AccessRight[] | undefined): boolean {
  return hasRole("cfo", accessRights);
}

export function isSuperAdmin(accessRights: AccessRight[] | undefined): boolean {
  return hasRole("super_admin", accessRights);
}
